
const getTip = (id) => {
  let msg = "";
  switch (id) {
    case 5003611: msg = "灵魂碎片：武将觉醒道具"; break;
    case 242944: msg = "达人虎符：游戏内重转锦囊的道具"; break;
    case 5004931:
      msg = "七夕宝匣：开启后随机获得一款皮肤";
      break;
    case 5004608:
      msg = "钥匙：开启任一单个宝匣需要消耗一把金钥匙";
      break;
    case 2:
      msg = "钥匙碎片：满100钥匙碎片自动合成一把“金钥匙";
      break;
    case 1:
      msg = "宝匣碎片：满100宝匣碎片自动合成一个“炎夏宝匣";
      break;
    case 5004216:
      msg = "翠珏：用于修复碎裂的古镜（背包内操作）";
      break;
    case 5003612:
      msg = "灵魂结晶：武将高级觉醒道具，指定单条7级以下的属性觉醒";
      break;
    case 5003613:
      msg = "灵魂精粹：武将高级觉醒道具，指定任一单条属性觉醒";
      break;
    case 5004214:
      msg = "颍川府铜钱：颍川府内霓裳阁及成衣铺货币";
      break;
    case 5004996:
      msg = "星集市将星立减券：星集市内购买道具支付时使用（详见星集市-我的优惠券）";
      break;
    case 5004997:
      msg = "星集市装饰立减券：星集市内购买道具支付时使用（详见星集市-我的优惠券）";
      break;
    case 5005006:
      msg = "星集市10星钻通用立减券：星集市内购买道具支付时使用（详见星集市-我的优惠券）";
      break;
    case 5005114:
      msg = "巳蛇宝匣：开启后随机获得一块碎裂的古镜";
      break;
    case 5004223: msg = "精忠拓片：可用于将星召唤活动中兑换精忠将星"; break;
    case 5004224: msg = "仁义拓片：可用于将星召唤活动中兑换精忠将星"; break;
    case 5005010: msg = "绿色皮肤洗点卡：可作为所有宝匣开出的绿色品质皮肤的重铸材料"; break;
    case 5005011: msg = "蓝色皮肤洗点卡：可作为所有宝匣开出的蓝色品质皮肤的重铸材料"; break;
    case 5005012: msg = "紫色皮肤洗点卡：可作为所有宝匣开出的紫色品质皮肤的重铸材料"; break;
    case 5005013: msg = "红色皮肤洗点卡：可作为所有宝匣开出的红色品质皮肤的重铸材料"; break;
    case 5005014: msg = "金色皮肤洗点卡：可作为所有宝匣开出的金色品质皮肤的重铸材料"; break;
    case 5005015: msg = "金色无双皮肤洗点卡：可作为所有宝匣开出的金色无双品质皮肤的重铸材料"; break;
    case 1000: msg = "1000荣誉：随机品质洗点卡*1（最高紫色），可作为同品质皮肤重铸材料"; break;
    case 1500: msg = "1500荣誉：随机品质洗点卡*1（最高紫色），可作为同品质皮肤重铸材料"; break;
    case 2000: msg = "2000荣誉：随机品质洗点卡*1（最高红色），可作为同品质皮肤重铸材料"; break;
    case 2750: msg = "2750荣誉：随机品质洗点卡*1（最高紫色），可作为同品质皮肤重铸材料"; break;
    case 3500: msg = "3500荣誉：随机品质洗点卡*1（最高紫色），可作为同品质皮肤重铸材料"; break;
    case 4250: msg = "4250荣誉：随机品质洗点卡*1（最高金色），可作为同品质皮肤重铸材料"; break;
    case 5000: msg = "5000荣誉：随机品质洗点卡*1（最高紫色），可作为同品质皮肤重铸材料"; break;
    case 6000: msg = "6000荣誉：数百枚精忠拓片（高概率），或数百枚仁义拓片（低概率），可于将星召唤中使用"; break;
    case 7000: msg = "7000荣誉：随机品质洗点卡*1（最高红色），可作为同品质皮肤重铸材料"; break;
    case 8000: msg = "8000荣誉：随机品质洗点卡*1（最高金色），可作为同品质皮肤重铸材料"; break;
    case 9000: msg = "9000荣誉：随机品质洗点卡*1（最高红色），可作为同品质皮肤重铸材料"; break;
    case 10000: msg = "10000荣誉：随机品质洗点卡*1（最高红色），可作为同品质皮肤重铸材料"; break;
    case 11000: msg = "11000荣誉：随机品质洗点卡*1（最高无双），可作为同品质皮肤重铸材料"; break;
    case 12000: msg = "12000荣誉：数百枚精忠拓片（高概率）、或数百枚仁义拓片（低概率）、或2400枚仁义拓片（极低概率），可于将星召唤中使用"; break;
  }
  return msg;
}
export default getTip;